var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-main',[_c('Modal'),_c('NotificationMessage'),_c('div',{staticClass:"main_container"},[_c('router-view')],1)],1),(!_vm.isErrorPage && _vm.notProfileRoute())?_c('Footer'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }